export default class NetworkConnectivityError extends Error {}
